/**
 * Compatibility shim for @mui/styles makeStyles.
 *
 * Wraps tss-react/mui's makeStyles to maintain the legacy API:
 *   const classes = useStyles()
 * instead of tss-react's native:
 *   const { classes } = useStyles()
 *
 * This allows all existing useStyles.js files and their consumers to work
 * unchanged with MUI v6 (which removed @mui/styles).
 */
import { makeStyles as tssMakeStyles } from 'tss-react/mui'

export default function makeStyles(stylesOrCreator) {
  const useHook = tssMakeStyles()(
    typeof stylesOrCreator === 'function' ? stylesOrCreator : () => stylesOrCreator,
  )
  return function useStyles(props) {
    const { classes } = useHook(props)
    return classes
  }
}
